'use strict';

module.exports = require('./lib/extend');



//////////////////
// WEBPACK FOOTER
// ./~/node.extend/index.js
// module id = 47
// module chunks = 0